<app-update-indicator-bar></app-update-indicator-bar>
<router-outlet></router-outlet>
<tour-step-template></tour-step-template>
